import { collabStateManager } from '@databases/collab-state-manager';
import { logError } from '@databases/logs';
import { type defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { currentSnackbarState } from '@databases/snackbar/snackbar';
import { type Database } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';
import { createEntry } from '@databases/utils/database/utils';

export const handleCreateEntry = async (
  selectedDatabase: Database,
  dispatch: ReturnType<typeof defaultStoreUtils.useDispatch>
) => {
  return new Promise((resolve) => {
    let isAddEntryPending = false;
    const entry = createEntry(selectedDatabase);
    const collabManager = collabStateManager.getCollabManager(selectedDatabase.contentId);

    if (collabManager) {
      collabManager.onPendingChanges((pending: boolean) => {
        if (isAddEntryPending && !pending) {
          resolve(entry.id);
        }
      });
    } else {
      const error = new Error('Could not select collab manager for entry creation');
      currentSnackbarState.setMessage(error.message, {
        showCloseButton: true
      });
      logError(error);
      resolve(undefined);
    }
    dispatch(
      addChangeToDraft(selectedDatabase.contentId, {
        type: DatabaseChangeType.ADD_ENTRY,
        entry
      })
    );
    isAddEntryPending = true;
  });
};
